import { useQueryClient } from "@tanstack/react-query";
import { useDialog } from "@shared/features/dialog/useDialog";
import { useUpdateUserPhaseActionStatus } from "@platform/hooks/useUpdateUserPhaseActionStatus";
import { QuizProvider } from "../../../quiz/QuizContext";
import { QuizDialogContainer } from "../../../quiz/components/Quiz/QuizDialogContainer";
import { useNavigate, useLocation } from "react-router-dom";

export function ProgramPhasesQuizFormContainer() {
  const { pathname } = useLocation();

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { activeDialog, closeDialog, dialogProps } = useDialog();

  const { mutate: updateUserPhaseActionStatus } =
    useUpdateUserPhaseActionStatus({
      userPhaseActionId: dialogProps?.userPhaseActionId,
      status: "completed",
    });

  const isOpen = activeDialog === "quiz";

  const handleClose = () => {
    closeDialog("quiz");

    queryClient.invalidateQueries({
      queryKey: ["quiz-response", dialogProps?.quizResponseId],
    });
  };

  const handleDone = () => {
    closeDialog("quiz");

    updateUserPhaseActionStatus();

    if (pathname !== "/dashboard") {
      navigate("/dashboard");
    }
  };

  return (
    <QuizProvider>
      <QuizDialogContainer
        onDone={handleDone}
        onClose={handleClose}
        isOpen={isOpen}
        quizResponseId={dialogProps?.quizResponseId}
      />
    </QuizProvider>
  );
}

export default ProgramPhasesQuizFormContainer;
